import React from 'react';
import { useQuery } from '@apollo/client';
import { GET_STREAMLINE_STATUS } from '../graphql/queries';
import { useAuth } from '../contexts/AuthContext';
import VersionDisplay from './VersionDisplay';

export default function Footer() {
  const { user } = useAuth();
  const { data: streamlineData, loading: streamlineLoading, error: streamlineError } = useQuery(GET_STREAMLINE_STATUS, {
    pollInterval: 0, // Disable polling - only check on page load
    fetchPolicy: 'cache-first', // Use cache to avoid repeated API calls
    skip: user?.role !== 'ADMIN', // Skip the query if user is not admin
    onError: () => {} // Silently handle errors
  });

  return (
    <footer className="bg-sky-900 text-white p-4">
      <div className="container mx-auto flex flex-col space-y-2 md:space-y-0 md:flex-row md:justify-between md:items-center">
        <div className="text-sm text-center md:text-left">
          © {new Date().getFullYear()} Sweetgrass App. All rights reserved.
        </div>
        {user?.role === 'ADMIN' && !streamlineError && (
          <div className="flex items-center justify-center md:justify-start space-x-2 text-sm">
            <div className={`h-2 w-2 rounded-full ${streamlineData?.getStreamlineStatus?.isConnected ? 'bg-green-500' : 'bg-red-500'}`}></div>
            <span>
              {streamlineData?.getStreamlineStatus?.isConnected ? 'Connected' : 'Disconnected'}
              {streamlineData?.getStreamlineStatus?.lastCheck &&
                ` (${new Date(streamlineData.getStreamlineStatus.lastCheck).toLocaleTimeString()})`}
            </span>
          </div>
        )}
        <div className="text-gray-400 text-xs font-mono text-center md:text-right flex items-center space-x-1">
          <span>SG Operations Web Application</span>
          <VersionDisplay />
        </div>
      </div>
    </footer>
  );
} 